const NAME = 'INTERCOM';
const CNameMapping = {
  [NAME]: NAME,
  Intercom: NAME,
  intercom: NAME,
};

export { NAME, CNameMapping };
